import React from 'react';

const UserIcon = ({ on = true }) => {
  return (
    <svg id="icon-user-wrapper" viewBox="0 0 100 100">
      <circle cx="50" cy="50" r="40" />
      <svg aria-labelledby="" role="img">
        <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref={`#bhf_icon-user`} />
      </svg>
    </svg>
  );
};

export default UserIcon;
